import {
  fallbackText,
  getDataFromLink,
  Prismic,
  PrismicLink,
  PrismicText,
} from '@landsbankinn/prismic';
import { Button, theme } from '@landsbankinn/ui';
import { hyphenate } from '@landsbankinn/utils';
import React from 'react';
import {
  BackgroundColor,
  SubPageHero,
} from '../components/hero-sub/SubPageHero';

interface IProps {
  background_color: BackgroundColor;
  title: Prismic.RichText;
  copy: Prismic.RichText;
  smaller_font: boolean;
  image: Prismic.Image;
  hero_video?: Prismic.Image;
  video?: Prismic.Image;
  image_overflow?: boolean;
  button_text: Prismic.RichText;
  link: Prismic.Link;
  button_text_2?: Prismic.RichText;
  link_2?: Prismic.Link;
  // @todo
  special_hero: string;
}

const BackgroundColorMap = {
  'Blue Gradient': BackgroundColor.BLUE_GRADIENT,
  'Light Blue': BackgroundColor.LIGHT_BLUE,
  'Light Orange': BackgroundColor.LIGHT_ORANGE,
  Aukakronur: BackgroundColor.AUKAKRONUR,
};

export const SubPageHeroContainer = ({
  background_color,
  title,
  copy,
  special_hero,
  smaller_font,
  image,
  hero_video,
  video,
  image_overflow,
  button_text,
  link,
  button_text_2,
  link_2,
}: IProps) => {
  const buttonLinkdata = getDataFromLink(link);
  const buttonTitle = fallbackText(
    button_text,
    buttonLinkdata.title ?? undefined,
  );

  const buttonLinkdata2 = getDataFromLink(link_2);
  const buttonTitle2 = fallbackText(
    button_text_2 as any,
    buttonLinkdata2.title ?? undefined,
  );

  const action2 = link_2 ? (
    <PrismicLink value={link_2} title={buttonTitle2 ?? undefined}>
      <Button as="a" title={buttonTitle2 ?? undefined} id="main_cta_button" />
    </PrismicLink>
  ) : null;

  const action = link ? (
    <PrismicLink value={link} title={buttonTitle ?? undefined}>
      <Button
        as="a"
        title={buttonTitle ?? undefined}
        bordered={!!action2}
        bg={
          !!action2 && background_color !== 'Blue Gradient'
            ? theme.colors.primary
            : !!action2 && background_color === 'Blue Gradient'
            ? '#fff'
            : theme.colors.secondary
        }
        id={!!action2 ? 'secondary_cta_button' : 'main_cta_button'}
      />
    </PrismicLink>
  ) : null;

  let titleEl: string | null | React.ReactNode = hyphenate(Prismic.text(title));

  // check for image as title
  if ((title as any)?.[0]?.type === 'image') {
    titleEl = (
      <img
        src={(title as any)[0].url}
        alt={(title as any)[0].alt}
        style={{ height: 57 }}
      />
    );
  }

  return (
    <SubPageHero
      title={titleEl}
      description={<PrismicText value={copy} hyphenate />}
      image={image}
      video={hero_video ?? video}
      backgroundColor={BackgroundColorMap[background_color]}
      actions={action}
      actions2={action2}
      smallerFont={smaller_font}
      overflow={image_overflow}
      specialHero={special_hero}
    />
  );
};
